import React from 'react'
import pluralize from 'pluralize'
import { InfoButton } from 'src/components/PageLayout/InfoButton'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from 'src/components/Reusable/Tooltip/Tooltip'
import { ChatInfoIcon } from './chatPanel.styles'

// The info icon beside a chat's title, in TI and the copilot.
export const ChatInfoTooltip = ({
  id,
  isReadOnly,
  ownerName,
  aiQuestionCredits,
}: {
  id: string
  isReadOnly: boolean
  ownerName: string
  // Undefined until the first messages poll brings it.
  aiQuestionCredits?: number
}): JSX.Element => (
  // Stops the click here: inside an editable title, it would open the title for editing.
  <ChatInfoIcon onClick={(e) => e.stopPropagation()}>
    {/* Not InfoTooltip: its icon is a span, which the keyboard can't reach. */}
    <Tooltip
      id={id}
      trigger={['hover', 'focus']}
      placement={TooltipPositions.bottom}
      overlayType={TooltipOverlayType.popover}
      tooltipBody={
        <>
          {isReadOnly
            ? `Chat created by ${ownerName}. Title not editable.`
            : 'Chat created by you.'}
          {aiQuestionCredits !== undefined && (
            <>
              <br />
              {pluralize('AI question credit', aiQuestionCredits, true)} used.
            </>
          )}
        </>
      }
    >
      <InfoButton type="button" aria-label="Chat info" ml="xs" />
    </Tooltip>
  </ChatInfoIcon>
)
